const RESIZE_WIDTHS = [320, 480, 640, 800, 960, 1280, 1600];

export const buildSrcSet = (imageUrl) => {
  if (!imageUrl) return null;
  try {
    const u = new URL(imageUrl);
    const match = u.pathname.match(/^\/assets\/uploads\/([^/]+)\/([^/]+)$/);
    if (!match) return null;
    const [, folder, file] = match;
    const endpoint = `${u.origin}/images/${folder}/${file}?w=`;
    return RESIZE_WIDTHS.map((width) => `${endpoint}${width} ${width}w`).join(", ");
  } catch (e) {
    return null;
  }
};